import React from 'react';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onSignup, onLogin }) => {
  return (
    <section className="relative bg-gradient-to-b from-muted/50 to-background py-20 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-center lg:text-left">
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground mb-6">
              Strengthen Your Connection Through{' '}
              <span className="text-primary">AI-Guided Intimacy</span>
            </h1>
            <p className="font-caption text-xl sm:text-2xl text-primary/80 italic mb-4">
              Sometimes Love just needs a little Nudge
            </p>
            <p className="text-lg sm:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto lg:mx-0">
              Navigate sensitive conversations, discover deeper compatibility, and nurture your relationship with intelligent, private tools designed for couples.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={onSignup}
                className="text-base px-8 py-6 h-auto shadow-therapeutic-lg hover:shadow-therapeutic transition-all"
              >
                Start Your Journey
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={onLogin}
                className="text-base px-8 py-6 h-auto"
              >
                Welcome Back
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>End-to-end encrypted</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>HIPAA compliant</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Therapist endorsed</span>
              </div>
            </div>
          </div>

          {/* Right Column - Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-therapeutic-lg">
              <div className="aspect-[4/3] bg-gradient-to-br from-primary/20 via-secondary/10 to-accent/20 flex items-center justify-center">
                <div className="text-center p-8">
                  <div className="w-24 h-24 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
                    <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <p className="text-muted-foreground font-caption text-sm">Couple connecting through meaningful conversation</p>
                </div>
              </div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-card rounded-xl shadow-therapeutic p-4 border border-border hidden lg:block">
              <div className="text-2xl font-heading font-semibold text-primary">94%</div>
              <div className="text-sm text-muted-foreground">Improved communication</div>
            </div>
            <div className="absolute -top-6 -right-6 bg-card rounded-xl shadow-therapeutic p-4 border border-border hidden lg:block">
              <div className="text-2xl font-heading font-semibold text-accent">10k+</div>
              <div className="text-sm text-muted-foreground">Couples trust us</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;